// Package Imports
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

// Enums
import { MessageResult } from '../../enums';

// Models
import { Message } from '../../models';

@Component({
  selector: 'app-message-box-modal',
  templateUrl: './message-box-modal.component.html',
  styleUrls: [
    '../../styles/shared.css',
    './message-box-modal.component.css'
  ]
})
export class MessageBoxModalComponent {
  result: MessageResult;
  message = new Message();
  confirmFn: any;
  closeFn: any;
  parentOverlayComponent: any;
  canGetParentComponent = false;

  constructor(public bsModalRef: BsModalRef) {
    this.tryGetParentDocument();

    if (this.canGetParentComponent) {
      this.parentOverlayComponent.hidden = false;
    }
  }

  confirm(): void {
    this.result = MessageResult.OkPressed;
    this.bsModalRef.hide();

    if (this.canGetParentComponent) {
      this.parentOverlayComponent.hidden = true;
    }

    if (typeof this.confirmFn === 'function') {
      this.confirmFn();
    }
  }

  close(): void {
    this.result = MessageResult.ClosePressed;
    this.bsModalRef.hide();

    if (this.canGetParentComponent) {
      this.parentOverlayComponent.hidden = true;
    }

    if (typeof this.closeFn === 'function') {
      this.closeFn();
    }
  }

  private tryGetParentDocument() {
    try {
      this.parentOverlayComponent = parent.document.getElementById('modalOverlayBackground');
      this.canGetParentComponent = this.parentOverlayComponent != null;
    }
    catch (error) {
      this.canGetParentComponent = false;
    }
  }
}
